import { RouteNameEnum } from "@/v2/enumerate/route";
import { PermissionEnum } from "@/v2/enumerate/permission";

const v2 = (import.meta.env.VITE_VERSION) === "v2";

/**
 * 教會行事曆（core_admin_event 的 ref=2）
 *
 * 與服事同屬「行事曆管理」選單，但它是全教會可見的公告型行程，
 * 沒有名單/循環/提醒，所以新增與編輯都在清單頁的抽屜裡完成 ——
 * 不像服事那樣需要獨立的 create / edit 路由。
 */
const calendar = [
    {
        //教會行事曆 - 管理（清單 + 日曆雙檢視）
        path: "calendars",
        name: RouteNameEnum.ADMIN_CALENDAR,
        meta: {
            // 🎉🎉 切入v2需要添加 🎉🎉
            v2: v2,
            // ✝️✝️ 總教會僅讀取標記 ✝️✝️
            head: {
                readonly: true,
            },
            permission: 21001,
            // ⚙️⚙️ v2 授權群組 ⚙️⚙️
            group: PermissionEnum.ADMIN_CALENDAR,
            breadcrumb: [
                {
                    key: "admin.event.subject",
                    value: null,
                },
                {
                    key: "admin.calendar.index",
                    value: null,
                },
            ],
        },
        component: () => import("@/v2/page/content/core/admin/calendar/index.vue"),
    },
];

export default calendar;
